export default {
  LOCAL_SESSION: "_local_session", // Used to store local session data in cookies, hence the leading underscore.
  HAS_SELECTED_PROFILE: "hasSelectedProfile",
};
